import React, { Ref } from 'react'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import Select from 'react-select'

import './Select.css'

import {
  AutoCompleteProps,
  OptionItem,
} from '@/types/components/fields/autoComplete.types'
import FormError from '@/components/ui/FormError'

const AutoComplete = React.forwardRef(
  (props: AutoCompleteProps, ref: Ref<any>): JSX.Element => {
    const {
      options,
      id,
      field,
      fieldState,
      callBack,
      disabled = false,
      label,
      customRef = null,
      placeholder = null,
    } = props

    const { t } = useTranslation()
    return (
      <div className="mb-4">
        {label && (
          <label htmlFor={id} className={clsx('fw-semibold mb-3')}>
            {label}
          </label>
        )}
        <Select
          inputId={id}
          ref={customRef || ref}
          className={clsx('customSelect mb-2 basic-single', {
            'is-invalid': fieldState.error,
            hasValue: field.value,
          })}
          classNamePrefix="select"
          isDisabled={disabled}
          openMenuOnFocus={false}
          options={options}
          value={(() => {
            const selectedOption = options?.find(
              (x: OptionItem) => x.value == field.value
            )
            if (selectedOption) {
              return selectedOption
            }
            return undefined
          })()}
          getOptionValue={(o) => {
            if (o.value === undefined) {
              return ''
            }

            return o.value.toString()
          }}
          placeholder={placeholder ? placeholder : t('common.select')}
          onChange={(e) => {
            field.onChange(e?.value)
            callBack && callBack(e?.value)
          }}
          getOptionLabel={(o) => o.text}
        />
        <FormError message={fieldState.error?.message} />
      </div>
    )
  }
)

export default AutoComplete
